export enum EmailTypeEnum {
    Checklist = 1
}